import React, { useState, useEffect } from "react";
import { FaRegFileAlt } from "react-icons/fa";
import { MdOutlineCelebration } from "react-icons/md";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import "../styles/success.css";

const SuccessStories = () => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [stories, setStories] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [storyToDelete, setStoryToDelete] = useState(null);

  // New state for general popup message
  const [popupMessage, setPopupMessage] = useState(null);

  useEffect(() => {
    fetchImages();
  }, []);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const fetchImages = async () => {
    try {
      const response = await fetch(
        "https://shubhjiwan.co.in/ShubhJiwan_backend11/success_stories.php"
      );
      const data = await response.json();
      setStories(data);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const handleSubmit = async () => {
    if (!image) {
      // Show custom popup instead of alert
      setPopupMessage("Please select an image first.");
      return;
    }

    const formData = new FormData();
    formData.append("image", image);

    try {
      const response = await fetch(
        "https://shubhjiwan.co.in/ShubhJiwan_backend11/success_stories.php",
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      if (result.image) {
        setPopupMessage("Image uploaded successfully!");
        setImage(null);
        setPreview(null);
        fetchImages();
      } else {
        setPopupMessage(result.error || "Failed to upload image.");
      }
    } catch (error) {
      console.error("Error:", error);
      setPopupMessage("Something went wrong.");
    }
  };

  const confirmDelete = (story) => {
    setStoryToDelete(story);
    setShowDeletePopup(true);
  };

  const handleConfirmDelete = async () => {
    if (!storyToDelete) return;
    try {
      const response = await fetch(
        "https://shubhjiwan.co.in/ShubhJiwan_backend11/success_stories.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: storyToDelete.id }),
        }
      );
      const result = await response.json();
      if (result.message) {
        setPopupMessage("Image deleted successfully!");
        fetchImages();
      } else {
        setPopupMessage(result.error || "Failed to delete image.");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      setPopupMessage("Something went wrong while deleting.");
    }
    setShowDeletePopup(false);
    setStoryToDelete(null);
  };

  const handleCancelDelete = () => {
    setShowDeletePopup(false);
    setStoryToDelete(null);
  };

  // Close the message popup
  const closePopupMessage = () => setPopupMessage(null);

  return (
    <div
      style={{
        marginLeft: "260px",
        padding: "20px",
        borderRadius: "10px",
        background: "linear-gradient(to bottom, #eef5fc, #c1d9f0)",
      }}
    >
      <h2
        style={{
          color: "#2c3e50",
          fontSize: "24px",
          marginBottom: "15px",
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <MdOutlineCelebration /> Upload Success Story
      </h2>

      {/* Upload Section */}
      <div
        style={{
          padding: "20px",
          maxWidth: "700px",
          margin: "50px auto",
          textAlign: "center",
          marginBottom: "20px",
          borderRadius: "8px",
          background: "#ffffff",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
        }}
      >
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          style={{
            display: "block",
            margin: "10px auto",
            padding: "12px",
            border: "2px dashed #3498db",
            background: "#f8f9fa",
            borderRadius: "8px",
            cursor: "pointer",
            width: "80%",
            fontSize: "1rem",
          }}
        />
        {preview && (
          <img
            src={preview}
            alt="Preview"
            style={{
              display: "block",
              margin: "15px auto",
              width: "180px",
              height: "180px",
              objectFit: "cover",
              borderRadius: "10px",
              border: "3px solid #3498db",
            }}
          />
        )}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            onClick={handleSubmit}
            style={{
              background: "linear-gradient(135deg, #ff7e5f, #feb47b)",
              color: "white",
              padding: "12px 25px",
              border: "none",
              borderRadius: "50px",
              cursor: "pointer",
              fontSize: "1rem",
              transition: "transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease",
              marginTop: "20px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              boxShadow: "0 6px 8px rgba(0, 0, 0, 0.1)",
            }}
            onMouseOver={(e) => {
              e.target.style.background = "linear-gradient(135deg, #ff6a5f, #ffab7b)";
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 10px 15px rgba(0, 0, 0, 0.2)";
            }}
            onMouseOut={(e) => {
              e.target.style.background = "linear-gradient(135deg, #ff7e5f, #feb47b)";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 6px 8px rgba(0, 0, 0, 0.1)";
            }}
          >
            <FaCloudUploadAlt style={{ fontSize: "1.2rem" }} /> Upload
          </button>
        </div>
      </div>

      {/* Uploaded Stories Section */}
      <div
        style={{
          padding: "20px",
          borderRadius: "8px",
          background: "#ffffff",
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2
          style={{
            color: "#2c3e50",
            fontSize: "1.5rem",
            marginBottom: "15px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaRegFileAlt /> Uploaded Stories
        </h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "15px",
            padding: "10px",
          }}
        >
          {stories.map((story) => (
            <div
              key={story.id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "15px",
                borderRadius: "10px",
                background: "white",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <img
                src={`https://shubhjiwan.co.in/ShubhJiwan_backend11/${story.image}`}
                alt="Success Story"
                style={{
                  width: "180px",
                  height: "180px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
              <button
                onClick={() => confirmDelete(story)}
                style={{
                  marginTop: "10px",
                  background: "#e63946",
                  color: "white",
                  padding: "10px 18px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "background 0.3s ease, transform 0.2s ease",
                  boxShadow: "0 3px 6px rgba(230, 57, 70, 0.4)",
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#b8333a";
                  e.target.style.transform = "scale(1.05)";
                  e.target.style.boxShadow = "0 6px 12px rgba(184, 51, 58, 0.6)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#e63946";
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0 3px 6px rgba(230, 57, 70, 0.4)";
                }}
              >
                <FaTrashAlt /> Delete
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Delete Confirmation Popup */}
      {showDeletePopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h3 className="popup-heading">Confirm Delete</h3>
            <p className="popup-text">
              Are you sure you want to delete this image?
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
              <button onClick={handleConfirmDelete} className="popup-button">
                Yes, Delete
              </button>
              <button
                onClick={handleCancelDelete}
                className="popup-button"
                style={{ backgroundColor: "#aaa" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* General Popup Message */}
      {popupMessage && (
        <div className="popup-overlay">
          <div className="popup-container" style={{ maxWidth: "320px" }}>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#2c3e50",
                marginBottom: "20px",
                textAlign: "center",
              }}
            >
              {popupMessage}
            </p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={closePopupMessage}
                className="popup-button"
                style={{ backgroundColor: "#3498db", color: "white" }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessStories;
